import styles from "./QuantityBadge.module.css";

type Props = {
  children: number;
  status?: "neutral" | "plus" | "minus" | "special";
};

export const QuantityBadge = ({ children, status = "special" }: Props) => {
  let finalStatus = "special";
  if (status) finalStatus = status;

  const badgeClass = `${styles.box} ${styles[finalStatus] || ""}`;

  return <div className={badgeClass}>{children}</div>;
};
